import React from 'react';
import { SitecoreImageField, SitecoreLinkField } from 'components/sitecore-fields';
import { isEmpty } from '../../../sso/components/utils/obj-utils';
import {
    calculateRemainingDate,
    checkIfExpired
} from '../helpers/toch-helpers';

class Countdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            countdownTimer: Date.now(),
            days: null,
            minutes: null,
            hours: null
        };

        this.getRemainingDate = this.getRemainingDate.bind(this);
        this.isValidDate = this.isValidDate.bind(this);
    }

    isValidDate() {
        const { countdownTimer } = this.props.data;
        const newCountdownTimerDate = new Date(countdownTimer);
        const newDate = new Date('0001-01-01T00:00:00Z');

        if (newCountdownTimerDate !== newDate) return true;

        return false;
    }

    getRemainingDate() {
        const { countdownTimer } = this.props.data;
        const newDate = calculateRemainingDate(countdownTimer);

        this.setState({ days: newDate.days, hours: newDate.hours, minutes: newDate.minutes });
    }

    componentDidMount() {
        const { refreshTime } = this.props.data;
        const refresh = (isEmpty(refreshTime) || refreshTime === null || refreshTime === undefined) ? 60000 : refreshTime;

        this.interval = setInterval(() => this.getRemainingDate(), refresh);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const {
            countdownTimer,
            mainSubtitle,
            mainTitle,
            countdownDaysText,
            countdownHoursText,
            countdownMinutesText,
            secondarySubtitle,
            secondaryTitle,
            link,
            logo,
            isMastercardComponent,
            isInEditMode,
        } = this.props.data;
        const { days, hours, minutes } = this.state;

        const isExpired = checkIfExpired(countdownTimer);
        const isValidDate = this.isValidDate();

        const isValid = isExpired && isInEditMode;
        const showData = isValidDate || isValid;

        const newDate = (days === null && hours === null && minutes === null) ? calculateRemainingDate(countdownTimer) : null;
        const isMastercard = isMastercardComponent.toLowerCase() === 'true';
        const hasLogo = (logo !== null && logo !== '' && logo !== undefined);

        return (
            (!isExpired || isInEditMode) &&
            <div>
                {
                    isMastercard &&
                    <div className="mastercard-branding-light">
                    </div>
                }
                <div className="countdown__wrap">
                    <div className="countdown__content">
                        <div className="countdown__tickets">
                            <div className="countdown__tickets--content">
                                <div className="countdown__tickets--tag">
                                    {mainSubtitle}
                                </div>
                                <div className="countdown__tickets--heading">
                                    {mainTitle}
                                </div>
                                {
                                    showData &&
                                <div className="countdown__timer">
                                    <div className="countdown__timer--item">
                                        <div className="countdown__timer--value">
                                            {(days === null || days === undefined) ? newDate.days : days}
                                        </div>
                                        <div className="countdown__timer--label">
                                            {countdownDaysText}
                                        </div>
                                    </div>
                                    <div className="countdown__timer--item">
                                        <div className="countdown__timer--value">
                                            {(hours === null || hours === undefined) ? newDate.hours : hours}
                                        </div>
                                        <div className="countdown__timer--label">
                                            {countdownHoursText}
                                        </div>
                                    </div>
                                    <div className="countdown__timer--item">
                                        <div className="countdown__timer--value">
                                            {(minutes === null || minutes === undefined) ? newDate.minutes : minutes}
                                        </div>
                                        <div className="countdown__timer--label">
                                            {countdownMinutesText}
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                        <div className="countdown__branding">
                            <div className="countdown__branding--partner">
                                <div className="countdown__branding--subtitle">
                                    {secondarySubtitle}
                                </div>
                                <div className="countdown__branding--logo">
                                    {
                                        hasLogo &&
                                            <SitecoreImageField img={logo}></SitecoreImageField>
                                    }
                                </div>
                            </div>
                            <div className="countdown__branding--title">
                                {secondaryTitle}
                            </div>
                            <div className="countdown__branding--link">
                                <SitecoreLinkField className='button button--primary' link={link} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Countdown;
